// Add these to your BIE API module and adjust service/action names to match middleware.

import { postBiz, rows, json, fetchCombo } from '../core/coreapi';

export const buildScenarioAssumptions = (scc = 'DET2027_BASE') =>
  postBiz({ s: 'biescenarioassumption', a: 'build', scc });

export const fetchBieObjectiveGaps = async (scenarioCode: string) =>
  rows(await postBiz({ s:'bieobjectivegaps', a:'find', scc: scenarioCode }));

export const fetchBieConstraints = async (scenarioCode: string) =>
  rows(await postBiz({s: 'bieconstraints', a:'find', scc: scenarioCode }));

export const fetchBieEntries = async (scenarioCode: string) =>
  rows(await postBiz({s:'bieentry', a:'find', scc: scenarioCode })).map((r: any, i: number) => ({
    id: r.id || r.rid || r.recid || `entry-${i}`,
    rid: r.rid || r.recid || null,
    etc: r.etc || r.entrytypecode || '',
    pdc: r.pdc || r.periodcode || '',
    enc: r.enc || r.entitycode || '',
    lcc: r.lcc || r.locationcode || '',
    acc: r.acc || r.accountcode || '',
    drc: r.drc || r.drivercode || '',
    ref: r.ref || r.reference || '',
    qty: Number(r.qty || r.quantity || 0),
    upr: Number(r.upr || r.unitprice || 0),
    amt: Number(r.amt || r.amount || 0),
    dsc: r.dsc || r.description || '',
    _state: 'clean',
    raw: r,
  }));

export const saveBieEntries = async (scenarioCode: string, rowsIn: any[]) =>
  json(await postBiz({
    s: 'bieimport', 
    a: 'console', 
    trk: null,
    soc: 'MANUAL',
    scc: scenarioCode,
    rcd: rowsIn
      .filter((r: any) => r._state && r._state !== 'clean')
      .map((r: any) => ({ scc: scenarioCode, ...r })),
    fnm: 'manual_datagrid_entries.json',
    fdt: {},
    att: {},
    exi: { origin: 'BieEntryGrid' },
    rmk: 'Manual editable DataGrid',
  }));

export const resetBieScenarioWorkingSet = async (scenarioCode: string) =>
  json(await postBiz({s:'bie', a:'reset', scc: scenarioCode }));

export const fetchBieLookupPack = async () => {
  const [entryTypes, periods, entities, locations, accounts, drivers] = await Promise.all([
    await fetchCombo('bieentrytype'),
    await fetchCombo('bieperiod'),
    await fetchCombo('bieentity'),
    await fetchCombo('bielocation'),
    await fetchCombo('bieaccount'),
    await fetchCombo('biedriver'),
  ]);

  return { entryTypes, periods, entities, locations, accounts, drivers };
};
